
const digest = '7f23da1e28c8ad3226582a97c2f9f824670851cdeca7fa97e2e552c98532665d';
const classes = {"item":"_item_rcr6w_1","title":"_title_rcr6w_9","noBefore":"_noBefore_rcr6w_15","disabled":"_disabled_rcr6w_22","active":"_active_rcr6w_26"};
const css = `._item_rcr6w_1 {
  padding: 4px 12px;
  background-color: #fff;
  border-radius: 15px;
  border: 1px solid #eaedf3;
  min-width: fit-content;
  cursor: pointer;
}
._item_rcr6w_1 ._title_rcr6w_9 {
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #3e3f42;
}
._item_rcr6w_1 ._title_rcr6w_9._noBefore_rcr6w_15:before {
  content: none;
}
._item_rcr6w_1 ._title_rcr6w_9:before {
  counter-increment: stepper;
  content: counter(stepper) ". ";
}
._item_rcr6w_1._disabled_rcr6w_22 {
  pointer-events: none;
  background: gray;
}
._item_rcr6w_1._active_rcr6w_26 {
  background-color: #1d65d8;
  border-color: #1d65d8;
}
._item_rcr6w_1._active_rcr6w_26 ._title_rcr6w_9 {
  color: #ffffff;
  font-weight: 500;
}
._item_rcr6w_1._disabled_rcr6w_22 {
  background: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.5;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  